import { Link, NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Users, ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/customers", label: "Customers", icon: Users },
];

export default function AdminShell({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const current = NAV.find((n) => (n.end ? pathname === n.to : pathname.startsWith(n.to)));

  return (
    <div className="container py-10">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <Link to="/" className="mb-2 inline-flex items-center gap-1 text-xs font-medium text-body hover:text-brand">
            <ArrowLeft className="h-3 w-3" /> Back to site
          </Link>
          <h1 className="text-2xl font-bold tracking-tight">{current?.label ?? "Admin"}</h1>
        </div>
      </div>

      <div className="grid gap-8 lg:grid-cols-[220px,1fr]">
        <aside>
          <nav className="space-y-1 text-sm">
            {NAV.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-2 rounded-md px-3 py-2",
                    isActive ? "bg-brand-50 font-semibold text-brand" : "text-body hover:bg-surface"
                  )
                }
              >
                <Icon className="h-4 w-4" /> {label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section>{children}</section>
      </div>
    </div>
  );
}
